


import {
  defineComponent,
  reactive,
} from '@vue/composition-api';
import useSettouSagyou from '@/components/Sp/Johaisetsu/SettouSagyou/composables/useSettouSagyou';

interface State {
  showConfirmTemporarilyStopWorkingModal: boolean;
  showConfirmStopWorkingModal: boolean;
}

export default defineComponent({
  props: {
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive<State>({
      showConfirmTemporarilyStopWorkingModal: false,
      showConfirmStopWorkingModal: false,
    });
    const {
      johaisetsuTypeGroupName,
      johaisetsuTypeNameDisp,
    } = useSettouSagyou({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const editContentAndRoad = () => {
      emit('editContentAndRoadOnCommon');
    };
    const showConfirmTemporarilyStopWorkingModal = () => {
      state.showConfirmTemporarilyStopWorkingModal = true;
    };
    const showConfirmStopWorkingModal = () => {
      state.showConfirmStopWorkingModal = true;
    };
    const temporarilyStopWorking = () => {
      state.showConfirmTemporarilyStopWorkingModal = false;
      emit('temporarilyStopWorkingOnCommon');
    };
    const stopWorking = () => {
      state.showConfirmStopWorkingModal = false;
      emit('stopWorkingOnCommon');
    };
    return {
      state,
      johaisetsuTypeGroupName,
      johaisetsuTypeNameDisp,
      editContentAndRoad,
      showConfirmTemporarilyStopWorkingModal,
      temporarilyStopWorking,
      showConfirmStopWorkingModal,
      stopWorking,
    };
  },
});
